// extracted by mini-css-extract-plugin
export default {"body":"dashboardstyle_body__MjMFm","body-pd":"dashboardstyle_body-pd__tj6Xy","show":"dashboardstyle_show__2o0eO","active":"dashboardstyle_active__EyYOi"};